var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDairyfree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117 474 c-4 -4 -7 -24 -7 -44 0 -28 -8 -43 -35 -70 l-35 -34 0 -163 0 -163 200 0 200 0 0 163 0 163 -34 34 c-27 25 -36 43 -38 74 l-3 41 -121 3 c-66 1 -123 -1 -127 -4z m213 -49 c0 -12 -17 -15 -90 -15 -73 0 -90 3 -90 15 0 12 17 15 90 15 73 0 90 -3 90 -15z m28 -67 c23 -23 11 -28 -66 -28 -66 0 -82 3 -97 20 -18 20 -17 20 66 20 53 0 90 -5 97 -12z m-178 -185 l0 -133 -55 0 -55 0 0 129 c0 125 1 130 26 161 l27 31 28 -27 29 -28 0 -133z m230 -8 l0 -125 -95 0 -95 0 0 125 0 125 95 0 95 0 0 -125z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairyfree);
export default __webpack_public_path__ + "static/media/dairyfree.cc6bd7ecb27b2ebc2e35861bd52a550f.svg";
export { ForwardRef as ReactComponent };